/**
 * Convert a possible string containing a number to a number.
 */
export default function ensureNumber(number: number | string): number {
    if (typeof number === 'number') {
        return number;
    }
    return Number.parseFloat(number);
}
